import React, { useEffect } from "react";
import unsortedIcon from "../../../assets/images/png/upDown.png";
import sortedIcon from "../../../assets/images/png/sortedIcon.png";
import sortedAtoz from "../../../assets/images/png/descSortIcon.png";

const Table = ({ tableData, handleSort, currentSortKey, order }) => {
  useEffect(() => {
    setTimeout(() => {
      handleSort("mod_duration", "desc");
    }, 1000);
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <div className="portfolio_aging_table">
        <table className="fixed_income_table">
          <tr
            style={{
              marginBottom: "10px",
            }}
          >
            <th
              onClick={() => handleSort("description")}
              className="duration_analysis_label"
              style={{ paddingLeft: "12px" }}
            >
              Instrument Name{" "}
              <img
                src={
                  currentSortKey === "description" && order === "asc"
                    ? sortedIcon
                    : currentSortKey === "description" && order === "desc"
                    ? sortedAtoz
                    : unsortedIcon
                }
                alt=""
              />
            </th>
            <th className="head_custom"></th>
            <th className="head_custom"></th>
            <th
              className="head_custom duration_analysis_label"
              onClick={() => handleSort("ytm")}
              style={{ paddingRight: "20px" }}
            >
              YTM
              <img
                className="sort_icon"
                src={
                  currentSortKey === "ytm" && order === "asc"
                    ? sortedIcon
                    : currentSortKey === "ytm" && order === "desc"
                    ? sortedAtoz
                    : unsortedIcon
                }
                alt=""
              />
            </th>
            <th
              onClick={() => handleSort("mod_duration")}
              className="head_custom duration_analysis_label"
              style={{ paddingRight: "20px" }}
            >
              Mod Duration
              <img
                className="sort_icon"
                src={
                  currentSortKey === "mod_duration" && order === "asc"
                    ? sortedIcon
                    : currentSortKey === "mod_duration" && order === "desc"
                    ? sortedAtoz
                    : unsortedIcon
                }
                alt=""
              />
            </th>
          </tr>
          {tableData?.map((data) => {
            if (data.description !== "Total") {
              return (
                <tr className="portfolio_table_card">
                  <td>
                    <div
                      style={{
                        fontFamily: "Encode Sans",
                        fontWeight: 600,
                        fontSize: "14px",
                        lineHeight: "18.2px",
                        color: "#060F1F",
                      }}
                      className="instrument_data"
                    >
                      {data.description}
                    </div>
                  </td>
                  <td className="data_custom">
                    <div
                      style={{
                        fontFamily: "Roboto",
                        fontWeight: 500,
                        fontSize: "14px",
                        lineHeight: "21.2px",
                        color: "#060F1F",
                      }}
                      className="days_held_data"
                    >
                      {data.days_held}
                    </div>
                  </td>
                  <td className="data_custom">
                    <div
                      style={{
                        fontFamily: "Roboto",
                        fontWeight: 500,
                        fontSize: "14px",
                        lineHeight: "21.6px",
                        color: "#060F1F",
                      }}
                      className="quantity_data"
                    >
                      {data.quantity}
                    </div>
                  </td>
                  <td className="data_custom">
                    <div
                      style={{
                        fontFamily: "Roboto",
                        fontWeight: 500,
                        fontSize: "14px",
                        lineHeight: "21.6px",
                        color: "#060F1F",
                        paddingRight: "20px",
                      }}
                      className="quantity_data"
                    >
                      {data.ytm}%
                    </div>
                  </td>
                  <td className="data_custom">
                    <div
                      style={{
                        fontFamily: "Roboto",
                        fontWeight: 500,
                        fontSize: "14px",
                        lineHeight: "21.6px",
                        color: "#060F1F",
                        paddingRight: "20px",
                      }}
                      className="term_data"
                    >
                      {data.mod_duration}
                    </div>
                  </td>
                </tr>
              );
            } else return false;
          })}
        </table>
      </div>
    </div>
  );
};

export default Table;
